module.exports = __webpack_public_path__ + "static/img/8.ae1b0d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/8.png
// module id = 0r2R
// module chunks = 0